import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  listarActividades, editarActividad, eliminarActividad,
  dashboard, exportarPDFURL, exportarExcelURL,
  TIPOS_ATENCION, AREAS,
} from "./api";

const hoy = () => new Date().toISOString().slice(0, 10);
const POLI = new Set(["ALCALDE","REGIDOR","DIRECTOR DMU","SUBDIRECTOR ESPACIOS PÚBLICOS","DESPACHO","CONSERJE","AVANZADA ALCALDE"]);

export function TablaRegistros({ user, modo = "lectura" }) {
  // modo: lectura | supervisor | admin
  const [items, setItems] = useState([]);
  const [fdesde, setFdesde] = useState(hoy());
  const [fhasta, setFhasta] = useState(hoy());
  const [tipo, setTipo] = useState("");
  const [area, setArea] = useState("");
  const [estatus, setEstatus] = useState("");
  const [detalle, setDetalle] = useState(null);

  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, [fdesde, fhasta, tipo, area, estatus]);
  const cargar = async () => {
    try {
      const params = { fecha_desde: fdesde, fecha_hasta: fhasta };
      if (tipo) params.tipo_atencion = tipo;
      if (area) params.area = area;
      if (estatus) params.estatus = estatus;
      const r = await listarActividades(params);
      setItems(r.items || []);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error");
    }
  };
  const cambiarEstatus = async (id, nuevo) => {
    try { await editarActividad(id, { estatus: nuevo }); toast.success("Estatus actualizado"); cargar(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };
  const eliminar = async (id) => {
    if (!window.confirm("¿Cancelar este registro? Quedará marcado como CANCELADO.")) return;
    try { await eliminarActividad(id); toast.success("Cancelado"); cargar(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };

  const descargarPDF = () => window.open(exportarPDFURL({ fecha_desde: fdesde, fecha_hasta: fhasta }), "_blank");
  const descargarExcel = () => window.open(exportarExcelURL({ fecha_desde: fdesde, fecha_hasta: fhasta }), "_blank");

  return (
    <div className="via-card" data-testid="tabla-registros">
      <h2><i className="fa-solid fa-table-list"/> Registros</h2>
      <div className="via-form-grid">
        <div className="via-form-row"><label>Desde</label><input type="date" value={fdesde} onChange={(e) => setFdesde(e.target.value)}/></div>
        <div className="via-form-row"><label>Hasta</label><input type="date" value={fhasta} onChange={(e) => setFhasta(e.target.value)}/></div>
        <div className="via-form-row"><label>Tipo</label>
          <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
            <option value="">Todos</option>
            {TIPOS_ATENCION.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div className="via-form-row"><label>Área</label>
          <select value={area} onChange={(e) => setArea(e.target.value)}>
            <option value="">Todas</option>
            {AREAS.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div className="via-form-row"><label>Estatus</label>
          <select value={estatus} onChange={(e) => setEstatus(e.target.value)}>
            <option value="">Todos</option>
            <option>PENDIENTE</option><option>EN PROCESO</option><option>COMPLETADO</option><option>CANCELADO</option>
          </select>
        </div>
      </div>
      <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
        <button className="via-btn-ghost" onClick={descargarPDF} data-testid="btn-export-pdf"><i className="fa-solid fa-file-pdf"/> PDF</button>
        <button className="via-btn-ghost" onClick={descargarExcel} data-testid="btn-export-excel"><i className="fa-solid fa-file-excel"/> Excel</button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table className="via-tabla">
          <thead><tr>
            <th>Fecha</th><th>Tipo</th><th>Empleado</th><th>Área</th><th>Lugar</th><th>Bolsas/kg</th><th>ML</th><th>Estatus</th><th></th>
          </tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id} data-testid={`row-${it.id}`}>
                <td>{it.fecha}</td>
                <td>
                  <span className={`via-badge ${POLI.has(it.tipo_atencion) ? "via-badge-poli" : it.tipo_atencion === "CRC" || it.tipo_atencion === "OFICIO" ? "via-badge-crc" : "via-badge-ord"}`}>
                    {it.tipo_atencion}
                  </span>
                </td>
                <td>{it.nombre_empleado}</td>
                <td>{it.area_intervencion}</td>
                <td>{it.intervencion_en || it.ubicacion || "—"}</td>
                <td>{it.bolsas_negras || 0} / {it.basura_kg || 0}</td>
                <td>{it.metros_lineales ?? "—"}</td>
                <td>
                  {modo === "supervisor" ? (
                    <select value={it.estatus} onChange={(e) => cambiarEstatus(it.id, e.target.value)} data-testid={`sup-estatus-${it.id}`}>
                      <option>PENDIENTE</option><option>EN PROCESO</option><option>COMPLETADO</option><option>CANCELADO</option>
                    </select>
                  ) : (
                    <span className={`via-badge via-badge-${(it.estatus||"pendiente").toLowerCase().replace(/ /g,"")}`}>{it.estatus}</span>
                  )}
                </td>
                <td>
                  <button className="via-btn-ghost" style={{ padding: "4px 8px", fontSize: 12 }} onClick={() => setDetalle(it)}>Ver</button>
                  {modo === "admin" && <button className="via-btn-danger" style={{ marginLeft: 4 }} onClick={() => eliminar(it.id)}>×</button>}
                </td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={9} className="via-empty">Sin registros</td></tr>}
          </tbody>
        </table>
      </div>

      {detalle && (
        <div onClick={() => setDetalle(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "grid", placeItems: "center", zIndex: 100, padding: 20 }}>
          <div onClick={(e) => e.stopPropagation()} className="via-card" style={{ maxWidth: 600, width: "100%", maxHeight: "90vh", overflow: "auto" }} data-testid="modal-detalle">
            <h2>Detalle · {detalle.intervencion_en || "(sin lugar)"}</h2>
            <div style={{ fontSize: 13, lineHeight: 1.8 }}>
              <div><strong>Tipo:</strong> {detalle.tipo_atencion} {detalle.numero_crc_oficio && `· ${detalle.numero_crc_oficio}`}</div>
              {detalle.origen_solicitante && <div><strong>Origen:</strong> {detalle.origen_solicitante}</div>}
              <div><strong>Empleado:</strong> {detalle.nombre_empleado} {detalle.numero_unidad && `· Unidad ${detalle.numero_unidad}`}</div>
              <div><strong>Turno:</strong> {detalle.turno}</div>
              <div><strong>Área:</strong> {detalle.area_intervencion} {detalle.tipo_frente && `· ${detalle.tipo_frente}`}</div>
              <div><strong>Actividades:</strong> {(detalle.actividades || []).join(", ") || "—"}</div>
              <div><strong>Bolsas:</strong> {detalle.bolsas_negras || 0} · {detalle.basura_kg || 0} kg · {detalle.basura_toneladas || 0} ton</div>
              {detalle.metros_lineales != null && <div><strong>ML:</strong> {detalle.metros_lineales}</div>}
              {detalle.metros_cuadrados != null && <div><strong>m²:</strong> {detalle.metros_cuadrados}</div>}
              {detalle.metros_cubicos != null && <div><strong>m³:</strong> {detalle.metros_cubicos}</div>}
              {(detalle.coordenadas_alexa_lat ?? detalle.gps_lat) != null && (
                <div><strong>Coordenadas:</strong>{" "}
                  <a className="via-mapa-pin" target="_blank" rel="noreferrer"
                     href={`https://www.google.com/maps?q=${detalle.gps_lat ?? detalle.coordenadas_alexa_lat},${detalle.gps_lng ?? detalle.coordenadas_alexa_lng}`}>
                    <i className="fa-solid fa-map-pin"/>Ver en mapa
                  </a>
                </div>
              )}
              {detalle.notas && <div><strong>Notas:</strong> {detalle.notas}</div>}
            </div>
            <div className="via-foto-grid" style={{ marginTop: 12 }}>
              {[detalle.foto_inicio, detalle.foto_proceso, detalle.foto_final].map((src, i) => (
                <div key={i} className={`via-foto-box ${src ? "filled" : ""}`}>
                  {src ? <img src={src} alt={`f${i}`}/> : <div style={{ fontSize: 11, color: "#94A3B8" }}>{["INICIO","PROCESO","FINAL"][i]}</div>}
                </div>
              ))}
            </div>
            <button className="via-btn-ghost" style={{ marginTop: 12 }} onClick={() => setDetalle(null)}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
}

export function Dashboard() {
  const [data, setData] = useState(null);
  const [fdesde, setFdesde] = useState(hoy());
  const [fhasta, setFhasta] = useState(hoy());
  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, [fdesde, fhasta]);
  const cargar = async () => {
    try { setData(await dashboard({ fecha_desde: fdesde, fecha_hasta: fhasta })); }
    catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };
  if (!data) return <div className="via-empty">Cargando…</div>;
  const maxTipo = Math.max(1, ...data.por_tipo_atencion.map(x => x.n));
  return (
    <div data-testid="vial-dashboard">
      <div className="via-form-grid" style={{ marginBottom: 12 }}>
        <div className="via-form-row"><label>Desde</label><input type="date" value={fdesde} onChange={(e) => setFdesde(e.target.value)}/></div>
        <div className="via-form-row"><label>Hasta</label><input type="date" value={fhasta} onChange={(e) => setFhasta(e.target.value)}/></div>
      </div>
      <div className="via-grid-stats">
        <div className="via-stat"><div className="lbl">Actividades</div><div className="val">{data.totales.actividades}</div></div>
        <div className="via-stat"><div className="lbl">Bolsas → kg</div><div className="val">{data.totales.basura_kg}</div></div>
        <div className="via-stat"><div className="lbl">Toneladas</div><div className="val">{data.totales.basura_toneladas}</div></div>
        <div className="via-stat"><div className="lbl">Metros lineales</div><div className="val">{data.totales.metros_lineales}</div></div>
      </div>
      <div className="via-card">
        <h2>Por tipo de atención</h2>
        {data.por_tipo_atencion.map(x => (
          <div className={`via-bar ${POLI.has(x.tipo) ? "poli" : ""}`} key={x.tipo}>
            <span className="lbl">{x.tipo}</span>
            <div className="track"><div className="fill" style={{ width: `${(x.n/maxTipo)*100}%` }}/></div>
            <span className="n">{x.n}</span>
          </div>
        ))}
        {!data.por_tipo_atencion.length && <div className="via-empty">Sin datos en el período</div>}
      </div>
      <div className="via-card">
        <h2>Top 5 lugares</h2>
        <table className="via-tabla">
          <thead><tr><th>Lugar</th><th style={{ width: 80 }}>N</th></tr></thead>
          <tbody>
            {data.top_lugares.map((x, i) => <tr key={i}><td>{x.lugar}</td><td>{x.n}</td></tr>)}
            {!data.top_lugares.length && <tr><td colSpan={2} className="via-empty">Sin datos</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
